import "../../index46.css";
import { jsxs as c, jsx as t } from "react/jsx-runtime";
import { a as n } from "../../type-BFTbooL7.js";
import { _ } from "../../cs-piwRuCFZ.js";
import g from "../NumberOutput/index.js";
const v = "_progress-wrapper_1jf2u_1", h = "_title_1jf2u_7", N = "_total_1jf2u_11", j = "_progress_1jf2u_1", e = {
  progressWrapper: v,
  title: h,
  total: N,
  progress: j
};
function P(u) {
  const {
    className: f,
    title: r,
    description: a,
    totalValue: o,
    value: l,
    showPercentageInTitle: i,
    children: m
  } = u, d = n(l) ? l : 0, p = n(o) ? o : 0;
  let s;
  return p === 0 ? s = 0 : s = d / p * 100, /* @__PURE__ */ c("div", { className: _(e.progressWrapper, f), children: [
    (r || i) && /* @__PURE__ */ c("div", { className: e.title, children: [
      r,
      i && /* @__PURE__ */ t(
        g,
        {
          value: s,
          suffix: "%"
        }
      )
    ] }),
    /* @__PURE__ */ t("div", { className: e.total, children: /* @__PURE__ */ t(
      "div",
      {
        className: e.progress,
        style: {
          width: `${s}%`
        }
      }
    ) }),
    a && /* @__PURE__ */ t("div", { className: e.description, children: a }),
    m
  ] });
}
export {
  P as default
};
